import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWalletAccounts } from '../getWalletAccounts';
import { getVerifiedCredentialForWalletAccount } from '../utils/getVerifiedCredentialForWalletAccount';

type GetOwnerWalletAccountForSmartWalletAccountParams = {
  smartWalletAccount: WalletAccount;
};

export const getOwnerWalletAccountForSmartWalletAccount = (
  { smartWalletAccount }: GetOwnerWalletAccountForSmartWalletAccountParams,
  client = getDefaultClient()
): WalletAccount | undefined => {
  const smartWalletVerifiedCredential = getVerifiedCredentialForWalletAccount(
    { walletAccount: smartWalletAccount },
    client
  );

  assertDefined(
    smartWalletVerifiedCredential?.signerRefId,
    'Invalid smart wallet account'
  );

  return getWalletAccounts(client).find(
    (walletAccount) =>
      walletAccount.verifiedCredentialId ===
      smartWalletVerifiedCredential.signerRefId
  );
};
